import angular from 'angular';
import roleManagementComponent from './role-management.component';

let roleManagementModule = angular.module('roleManagement', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('roleManagement', roleManagementComponent);

export default roleManagementModule;



// WEBPACK FOOTER //
// ./client/pages/admin/role-management/role-management.js